import { fetchEndpoint } from "../network";

/**
 * 内容管理 - 视频管理
 */

export default {
  // 视频列表
  videos(params) {
    return fetchEndpoint("/create-platform/content/video", "GET", params);
  },
  //锁定
  lock(params) {
    return fetchEndpoint(
      "/create-platform/content/article/lock",
      "GET",
      params
    );
  },
  // 创建视频
  createVideo(params) {
    return fetchEndpoint("/create-platform/content/video", "POST", params);
  },

  // 视频详情
  detail(params) {
    return fetchEndpoint(
      "/create-platform/content/video/detail",
      "GET",
      params
    );
  },

  // 修改视频
  modify(params) {
    return fetchEndpoint(
      "/create-platform/content/video/modify",
      "POST",
      params
    );
  },
  //判断删除
  beforeRemove(params) {
    return fetchEndpoint(
      "/create-platform/contentOperation/contentOperationInfo",
      "GET",
      params
    );
  },
  // 删除视频
  remove(params) {
    return fetchEndpoint(
      "/create-platform/content/video/delete",
      "POST",
      params
    );
  },

  // 提交审核
  examine(params) {
    return fetchEndpoint(
      "/create-platform/content/video/examine",
      "POST",
      params
    );
  },

  // 发布
  publish(params) {
    return fetchEndpoint(
      "/create-platform/content/video/publish",
      "POST",
      params
    );
  },

  // 显示
  show(params) {
    return fetchEndpoint("/create-platform/content/video/show", "POST", params);
  },

  // 隐藏
  hide(params) {
    return fetchEndpoint(
      "/create-platform/content/video/hidden",
      "POST",
      params
    );
  },

  // 撤稿
  revert(params) {
    return fetchEndpoint(
      "/create-platform/content/article/revert",
      "POST",
      params
    );
  },

  // 弹窗中搜索合集列表
  searchCollection(params) {
    return fetchEndpoint(
      "/create-platform/content/config/collection",
      "GET",
      params
    );
  },

  // 弹窗中搜索合集列表
  searchCollection(params) {
    return fetchEndpoint(
      "/create-platform/content/config/collection",
      "GET",
      params
    );
  },

  // 批量修改媒体号
  batchModifyUser(params) {
    return fetchEndpoint(
      "/create-platform/content/modify-user",
      "POST",
      params
    );
  },

  baseConf(params) {
    return fetchEndpoint("/create-platform/longyuan/baseConf", "GET", params);
  },

  longyuanExamine(params) {
    return fetchEndpoint("/create-platform/longyuan/publish", "POST", params);
  },
  //视频手动转码
  videoTranscode(params) {
    return fetchEndpoint("/content/video/transcode", "POST", params);
  },
};
